import { render, staticRenderFns } from "./veStuHealthReply.vue?vue&type=template&id=4b58880c&scoped=true"
import script from "./veStuHealthReply.vue?vue&type=script&lang=js"
export * from "./veStuHealthReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58880c",
  null
  
)

export default component.exports